import { FileText, Truck, FileMinus, FilePlus } from "lucide-react";
import { Label } from "@/components/ui/label";
import { DTE_TYPE_LABELS } from "../types";
import type { DteTypeCode } from "../types";

interface DocumentTypeSelectorProps {
  value: DteTypeCode;
  onChange: (value: DteTypeCode) => void;
}

const DTE_TYPE_ICONS: Record<DteTypeCode, typeof FileText> = {
  33: FileText,
  34: FileText,
  52: Truck,
  56: FileMinus,
  61: FilePlus,
};

const DTE_TYPE_ORDER: DteTypeCode[] = [33, 34, 61, 56, 52];

export function DocumentTypeSelector({
  value,
  onChange,
}: DocumentTypeSelectorProps) {
  return (
    <div className="space-y-3">
      <Label>Tipo de Documento</Label>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {DTE_TYPE_ORDER.map((code) => {
          const Icon = DTE_TYPE_ICONS[code];
          const label = DTE_TYPE_LABELS[code];
          const isSelected = value === code;

          return (
            <button
              key={code}
              type="button"
              onClick={() => onChange(code)}
              className={`
                flex items-center gap-3 p-4 rounded-lg border-2 transition-colors text-left
                ${
                  isSelected
                    ? "border-primary bg-primary/5"
                    : "border-muted hover:border-muted-foreground/50"
                }
              `}
            >
              <Icon
                className={`h-5 w-5 ${isSelected ? "text-primary" : "text-muted-foreground"}`}
              />
              <div>
                <div
                  className={`text-sm font-medium ${isSelected ? "text-primary" : ""}`}
                >
                  {label}
                </div>
                <div className="text-xs text-muted-foreground">
                  Código {code}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
